import { createReducer } from '@reduxjs/toolkit';
import { SidebarMenuItem } from 'features/sidebar/ts-types';
import { sidebarActions } from 'features/sidebar/redux/sidebar.action';

export const initialState = {
  loadingStatus: false as boolean,
  listSidebarMenuItems: [] as SidebarMenuItem[],
  error: [] as string[],
} as const;

const sidebarReducer = createReducer(initialState, (builder) => {
  builder.addCase(sidebarActions.getSidebarMenuItemsRequest, (state) => {
    return {
      ...state,
      loadingStatus: true,
      listSidebarMenuItems: [],
    };
  });
  builder.addCase(
    sidebarActions.getSidebarMenuItemsSuccess,
    (state, action) => {
      return {
        ...state,
        loadingStatus: false,
        listSidebarMenuItems: action.payload.sidebarMenuItems,
      };
    }
  );
  builder.addCase(
    sidebarActions.getSidebarMenuItemsFailure,
    (state, action) => {
      return {
        ...state,
        loadingStatus: false,
        error: action.payload,
      };
    }
  );
});

export default sidebarReducer;
